import { RootState } from '../rootReducer'

export const selectFormTree = (state: RootState) => state.formTree.formTree
export const selectFormTreeReq = (state: RootState) => state.formTree.formTreeReq
export const selectFormArrayLentgh = (state: RootState) => state.formTree.formArrayLength
export const selectForceOpenPath = (state: RootState) => state.formTree.forceOpenPath
export const selectForceToSection = (state: RootState) => state.formTree.forceOpenToSection
export const selectFormTreeIsBig = (state: RootState) => state.formTree.isBig
export const selectFormIsFullInit = (state: RootState) => state.formTree.isFullInit
